module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if ( products && products.length ) { 
__p+='\n\n	<h5 class="normal">'+
((__t=( __('products_and_services') ))==null?'':__t)+
'</h5>\n\n	';
 _.each( products, function(item) { 
__p+='\n\n		<div class="class">\n\n			<div class="col images">\n				';
 if ( item.image ) { 
__p+='\n					<div class="image">\n						<div class="inner" style="background-image: url(//tramino.s3.amazonaws.com'+
((__t=( item.image ))==null?'':__t)+
')"></div>\n					</div>\n				';
 } else { 
__p+='\n					&nbsp;\n				';
 } 
__p+='\n			</div>\n\n			<div class="col info">\n\n				<h4>'+
((__t=( __('product') ))==null?'':__t)+
'</h4>\n				<h2>'+
((__t=( item.name ))==null?'':__t)+
'</h2>\n\n				<div class="line">\n					<div class="col text">\n						<div class="inner">\n							';
 if ( item.info ) { 
__p+='\n								';
 var s=item.info.substr( 0, 250); print(s); 
__p+='\n							';
 } 
__p+='\n						</div>\n					</div>\n					<div class="col facts">\n						<div class="inner">'+
((__t=( item.facts ))==null?'':__t)+
'</div>\n					</div>\n					<div class="clear"></div>\n				</div>\n\n				';
 if ( item.classes.length >= 2 ) { 
__p+='\n				<div class="subclasses" id="subclasses'+
((__t=( item.id ))==null?'':__t)+
'">\n					';
 _.each( item.classes, function(c) { 
__p+='\n					\n						<div class="subclass">\n\n							<div class="name">'+
((__t=( c.name ))==null?'':__t)+
'</div>\n							<div class="subclass-price">\n								<div class="subclass-amount">'+
((__t=( currencyHTML(  c.price, "EUR" ) ))==null?'':__t)+
'</div>\n								';
 if ( c.facts ) { 
__p+='<div class="subclass-facts">'+
((__t=( c.facts ))==null?'':__t)+
'</div>';
 } 
__p+='\n							</div>\n							<div class="subclass-action">\n								';
 if ( c.price && c.booking ) { 
__p+='\n								<div class="button-subclass button-booking" data-item="'+
((__t=( item.id ))==null?'':__t)+
'" data-class="'+
((__t=( c.id ))==null?'':__t)+
'">'+
((__t=( __('order') ))==null?'':__t)+
'</div>\n								';
 } 
__p+='\n							</div>\n							<div class="clear"></div>\n						</div>\n						\n					';
 }) 
__p+='\n				</div>\n				';
 } 
__p+='\n\n				';
 if ( item.text ) { 
__p+='\n					<div class="line details details-4">'+
((__t=( item.text.substr(0, 1000).replace("\n","<br>") ))==null?'':__t)+
'</div>\n				';
 } 
__p+='\n\n\n				';
 if ( item.link ) { 
__p+='\n					<a class="button button-prod-more" href="'+
((__t=( item.link ))==null?'':__t)+
'" target="_blank" rel="noopener">\n						'+
((__t=( __('more_info') ))==null?'':__t)+
'\n					</a>\n\n					<style type="text/css" media="screen">\n					a.button.button-prod-more {\n						min-width: 75px;\n						text-align: center;\n						display: inline-block;\n						text-transform: uppercase;\n						font-weight: bold;\n						font-size: 14px;\n						padding: 5px 30px;\n						color: #fff !important;\n						background-color: #444;\n						cursor: pointer;\n					}\n					a.button.button-prod-more:active {\n						text-decoration: none;\n					}\n					</style>\n				';
 } 
__p+='\n\n			</div>\n\n			<div class="col book">\n				<div class="inner">\n					';
 if ( item.price_min ) { 
__p+='\n						';
 if ( item.classes.length == 1 ) { 
__p+='\n							<div class="price">\n								'+
((__t=( currencyHTML( item.classes[0].price, "EUR" ) ))==null?'':__t)+
'\n							</div>\n							';
 if ( parseInt(item.booking, 10) > 0 ) { 
__p+='\n							<div class="button button-booking" data-item="'+
((__t=( item.id ))==null?'':__t)+
'" data-class="'+
((__t=( item.classes[0].id ))==null?'':__t)+
'">'+
((__t=( __('order') ))==null?'':__t)+
'</div>\n							';
 } 
__p+='\n						';
 } else { 
__p+='\n							<div class="price">\n								<span class="preis-ab">'+
((__t=( __('price_from') ))==null?'':__t)+
'</span>\n								'+
((__t=( currencyHTML( item.price_min, "EUR" ) ))==null?'':__t)+
'\n							</div>\n							<div class="button button-more" onclick="$(\'#subclasses'+
((__t=( item.id ))==null?'':__t)+
'\').slideDown(); $(this).fadeOut();">Mehr</div>\n						';
 } 
__p+='\n						';
 if ( item.classes[0].facts ) { 
__p+='\n							<div class="facts">\n								'+
((__t=( item.classes[0].facts ))==null?'':__t)+
'\n							</div>\n						';
 } 
__p+='\n					';
 } 
__p+='\n				</div>\n			</div>\n\n			<div class="clear"></div>\n		</div>\n\n	';
 }) 
__p+='\n\n';
 } else if ( error ) { 
__p+='\n\n	<div class="notify results-404">\n		<h3>Ein Fehler ist aufgetreten</h3>\n		'+
((__t=( error ))==null?'':__t)+
'\n	</div>\n\n';
 } else if ( 0 && isLoading ) { 
__p+='\n\n	<div class="notify results-loading">\n		<h3>Produkte werden geladen ...</h3>\n	</div>\n\n';
 } else if ( 0 ) { 
__p+='\n\n	<div class="notify results-404">\n		<h3>Keine Produkte gefunden</h3>\n	</div>\n\n';
 } 
__p+='\n';
}
return __p;
};


//////////////////
// WEBPACK FOOTER
// /Users/bm/app/code/jsapps/modules/reserva/templates/miniengine/products-template.html
// module id = 75
// module chunks = 0